import { useEffect, useState, useCallback } from "react";
import { isEmpty, inRange } from "lodash";

const useLimitHandler = ({
  profileData,
  detail,
  marketName,
  defaultStakeLimit,
  totalMatched,
  typeGame,
}) => {
  const [localLimit, setLocalLimit] = useState({});

  const handelLimit = useCallback(
    (marketName) => {
      const matchSettings = profileData?.matchSetting || [];
      const result = matchSettings.find((res) => res?.type === marketName);

      if (!isEmpty(result)) return result;

      const fallbackObj = matchSettings.find(
        (res) =>
          res?.type === "betFaire" &&
          (profileData?.arrayCheck === "details" ||
            res?.sportType === detail?.gameType)
      );

      if (isEmpty(fallbackObj)) {
        return {
          maxAmount: 500,
          maxProfit: 10000,
          minAmount: 1,
          oddsLimit: 20,
        };
      }

      // Special case for Match Odds
      if (marketName === "Match Odds" && !isEmpty(detail?.betLimitSetting)) {
        return {
          ...fallbackObj,
          minAmount: detail?.betLimitSetting?.minBet,
          maxAmount: detail?.betLimitSetting?.maxBet,
        };
      }

      return fallbackObj;
    },
    [profileData, detail]
  );

  useEffect(() => {
    if (detail?.gameType === "horse") {
      setLocalLimit({
        minAmount: 1,
        maxAmount: 200,
        oddsLimit: 100,
      });
      return;
    }

    if (["Winner", "Win"].includes(detail?.market)) {
      setLocalLimit({
        maxAmount: 100000,
        minAmount: 100,
        oddsLimit: 20,
      });
      return;
    }

    const limit = handelLimit(marketName);

    const newLimit = defaultStakeLimit?.find(
      (res) =>
        res?.betfairId === detail?.eventType &&
        res?.market === marketName &&
        inRange(totalMatched, res?.min, res?.max)
    );

    const findNewLimit = detail?.limit?.find(
      (res) => res?.type === (typeGame === "betFaire" ? "betFaire" : "bookmaker")
    );

    if (!isEmpty(findNewLimit)) {
      setLocalLimit({
        ...limit,
        maxAmount: Math.min(
          Number(limit?.maxAmount),
          Number(findNewLimit?.maxAmount)
        ),
        oddsLimit: Math.min(
          Number(limit?.oddsLimit),
          Number(findNewLimit?.oddsLimit)
        ),
      });
    } else {
      setLocalLimit(
        isEmpty(newLimit)
          ? limit
          : { ...limit, maxAmount: newLimit?.stake }
      );
    }
  }, [
    marketName,
    totalMatched,
    defaultStakeLimit,
    detail,
    typeGame,
    handelLimit,
  ]);

  return localLimit;
};

export default useLimitHandler;
